import * as React from 'react';

interface IComponentProps {
    message: string;
    type: 'error' | 'success';
    visible?: boolean;
}

interface IComponentState {
    visible: boolean;
}

class FeedbackMessage extends React.Component<IComponentProps, IComponentState> {
    static defaultProps: Partial<IComponentProps> = {
        visible: true,
    };

    constructor(props: IComponentProps) {
        super(props);

        this.state = {
            visible: !!props.visible,
        };
    }

    componentWillReceiveProps(nextProps: IComponentProps) {
        this.setState({
            visible: !!nextProps.visible,
        });
    }

    render() {
        const { type, message } = this.props;
        if (this.state.visible) {
            return (
                <div className={`ofx-feedback-message ${type}`}>
                    <div className="icon-container">
                        <div className="icon"></div>
                    </div>
                    <span className="message">{message}</span>
                </div>
            );
        }
        return null;
    }
}

export default FeedbackMessage;
